import React from "react";

import { IconAssistant } from "~/components/icon";

export const AssistantAvatar: React.FC = () => (
	<div className="flex size-8 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-white">
		<IconAssistant className="size-5" />
	</div>
);
